if (!customElements.get("recently-viewed")) {
  class RecentlyViewed extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector(".products-container");
      this.section = this.closest(".recently-viewed");
      this.recentProductIds = [];

      const requestUrl = this.buildRequestUrl();
      if (!requestUrl) {
        this.hide();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          this.fetchProductData(requestUrl);
        },
        { rootMargin: "0px 0px 400px 0px" }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    fetchProductData(url) {
      webvista
        .fetchHtml(url)
        .then((html) => this.handleHTML(html))
        .catch(() => this.hide());
    }

    handleHTML(html) {
      const templateContent = html.querySelector("template")?.content;
      const productList = templateContent?.querySelector(".slider-wrapper");

      if (!templateContent || !productList) {
        this.hide();
        return;
      }

      const orderedProducts = document.createDocumentFragment();

      this.recentProductIds.forEach((productId) => {
        const productItem = productList.querySelector(
          `li[data-product-id="${CSS.escape(String(productId))}"]`
        );
        if (productItem) orderedProducts.appendChild(productItem);
      });

      if (!orderedProducts.childNodes.length) {
        this.hide();
        return;
      }

      productList.replaceChildren(orderedProducts);
      this.container.replaceChildren(templateContent);
      this.section?.classList.remove("hidden");

      webvista.initLazyImages();
      webvista.initToolTips();
    }

    buildRequestUrl() {
      const maxDisplayCount = Number.parseInt(this.dataset.limit, 10) || 5;

      this.recentProductIds =
        webvista
          .retrieveData(RECENTLY_VIEWED_KEY)
          ?.slice(-maxDisplayCount)
          ?.reverse() || [];

      if (!this.recentProductIds.length) return null;

      const searchQuery = this.recentProductIds
        .map((id) => `id:${id}`)
        .join(" OR ");
      const queryParams = new URLSearchParams({
        q: searchQuery,
        type: "product",
        section_id: this.dataset.section,
        ose: "false",
      });

      return `${this.dataset.searchUrl}?${queryParams.toString()}`;
    }

    hide() {
      this.section?.classList.add("hidden");
    }
  }

  customElements.define("recently-viewed", RecentlyViewed);
}
